import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import TagManager from 'react-gtm-module';
import VConsole from 'vconsole';
import { observer } from 'mobx-react-lite';
import { getGeoInfoByIP } from '@triplabo/web/services/endpoints/geo';
import { geo, useStore } from '@triplabo/web/stores';
import { isWechat } from '@triplabo/web/utils';
import { showVConsole } from '@triplabo/web/utils/context';
import { Loading } from '@linktivity/link-icons';
import Map from '../Map';

import styles from './base.module.css';

const GTM_ENVIRONMENTS = ['develop', 'production'];

const BaseLayout: React.FC = observer(() => {
  const { mapInstance } = useStore();

  useEffect(() => {
    if (showVConsole) {
      const vConsole = new VConsole();
      return () => {
        vConsole.destroy();
      };
    }
  }, []);

  useEffect(() => {
    getGeoInfoByIP().then(geoIpInfo => {
      geo.setGeoIpInfo(geoIpInfo);
    });
  }, []);

  useEffect(() => {
    if (
      GTM_ENVIRONMENTS.includes(import.meta.env.VITE_APP_WEB_ENV) &&
      !isWechat
    ) {
      const tagManagerArgs = {
        gtmId: 'GTM-PWKR76ZV'
      };
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  return (
    <div className={styles.base}>
      <main className={styles.main}>
        <Map />
        {mapInstance.loaded ? (
          <Outlet />
        ) : (
          <Loading className={styles.loading} />
        )}
      </main>
    </div>
  );
});

export default BaseLayout;
